<template>
  <badge :loading="false" :type="statusType" :text="statusText"></badge>
</template>


<script>
import Badge from '@/components/Badge';

export default {
  props: ['status'],

  components: { Badge },

  data() {
    return {
      statusTypes: {
        open: {
          type: 'info',
          text: 'Offen',
        },
        completed: {
          type: 'success',
          text: 'Erfolgreich',
        },
        refunded: {
          type: 'default',
          text: 'Rückerstattet',
        },
        partially_refunded: {
          type: 'default',
          text: 'Teilrückerstattung',
        },
        cancelled: {
          type: 'default',
          text: 'Abgebrochen',
        },
      },
    };
  },

  computed: {
    statusType() {
      return this.statusTypes[this.status].type;
    },
    statusText() {
      return this.statusTypes[this.status].text;
    },
  },
};
</script>
